import { getXprops } from 'app/helpers/getXprops';

const parseResponse = async (response: Response) => {
  const responsePlain = await response.text();
  try {
    return JSON.parse(responsePlain);
  } catch {
    return responsePlain;
  }
};

export const buildFetch = async (response: Response) => {
  const responseJson = await parseResponse(response);
  if (!response.ok) {
    if (responseJson?.details) {
      throw responseJson;
    }
    throw { data: responseJson, status: response.status };
  }
  return responseJson;
};

export const customFetch = async (input: RequestInfo, init?: RequestInit | undefined): Promise<any> => {
  try {
    const { conektaSource } = getXprops();
    const customOptions = {
      method: 'GET',
      ...(init || {}),
      headers: {
        'Content-Type': 'application/json',
        ...(init?.headers || {}),
        'x-source': conektaSource,
      },
    };
    const response = await fetch(input, customOptions);

    return await buildFetch(response);
  } catch (e) {
    throw e;
  }
};
